import React from 'react';
import '../pageWelcome.css';
import AutoSizeTitle from '../../components/autoSizeTitle/AutoSizeTitle';
import { Typography } from 'antd';

const { Title, Text } = Typography;

const PageWelcomeSelfcare360 = ({ selectedEvaluation, pageNumber, orgName }) => {
    const backgroundStyle = {
        backgroundImage: `url('/informs/pagina.png')`,
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'left top',
        backgroundSize: '100% auto',
    };

    return (
        <div className="pdf-page internal-page">
            <div className="internal-page-content" style={backgroundStyle}>
                <AutoSizeTitle text={selectedEvaluation.evl_title} />

                <div className="internal-page-info internal-page-info-individual">
                    <Title level={4} style={{ color: '#339C98', marginBottom: 16 }}>
                        Bienvenido (a)!
                    </Title>
                    <div className='welcome-page-text'>
                        Queremos comenzar agradeciéndote por el tiempo y la apertura para participar en esta evaluación.
                        <br /><br />
                        Tu rol como supervisor(a) es clave en la operación, pero, sobre todo, en algo aún más importante: la seguridad y el cuidado de las personas que trabajan contigo cada día.
                        <br /><br />
                        En planta, la seguridad no depende solo de normas o procedimientos, depende principalmente de decisiones cotidianas: cómo se inicia el turno, cómo se corrige una desviación, cuándo se detiene un trabajo inseguro o cómo se prioriza la seguridad frente a la presión por producir. Esas acciones diarias, muchas veces pequeñas e invisibles, son las que previenen —o permiten— que ocurra un accidente.
                        <br /><br />
                        Este informe ha sido construido para ayudarte a ver esas prácticas con mayor claridad; integra distintas miradas (tu equipo, tu jefe, otras áreas y tu propia percepción) junto con indicadores operativos reales, para ofrecerte una visión completa de qué está funcionando bien y dónde puede existir riesgo antes de que se materialice.
                        <br /><br />
                        Su propósito no es evaluarte ni juzgarte, no es un proceso disciplinario; su propósito es preventivo y de acompañamiento: darte información concreta para que puedas anticiparte al riesgo, tomar mejores decisiones y fortalecer la seguridad de tu equipo. Porque en seguridad industrial sabemos algo con certeza: los accidentes rara vez son inesperados, casi siempre vienen precedidos por señales, pequeñas fallas o rutinas que pueden corregirse a tiempo. ¡Este informe te ayuda a detectar esas señales tempranas para cuidar tu vida y la de tu equipo!
                    </div>
                </div>

                <div className="internal-page-number">{pageNumber}</div>
            </div>
        </div>
    );
};

export default PageWelcomeSelfcare360;
